export default "__VITE_ASSET__CQH1aZM5__"